import { Grid2, Link, Typography } from "@mui/material";
import LoginLink from "../../containers/LoginLink";
import Logo from "../Logo";

import classes from './index.module.scss';

const Header = ({ linkList = [] }) => {
  return (
    <Grid2 container className={classes.header}>
      <Grid2>
        <Logo />
      </Grid2>
      <Grid2 container>
        {
          linkList.map((link) => {
            return (
              <Grid2 className={classes.linkContainer} key={link.title}>
                <Link href={link.href} target={link.target || '_blank'} className={classes.link}>
                  <Typography variant='body2' className={classes.linkTypography}>
                    {link.title}
                  </Typography>
                </Link>
              </Grid2>
            )
          })
        }
      </Grid2>
      <Grid2>
        <LoginLink />
      </Grid2>
    </Grid2>
  )
}

  export default Header;